import {
  EntityOperations,
  EventTypes,
  HandleEventCallback,
  IEntityResponseService,
} from './types';

export const createSubscribeEntityInScope = <
  TData extends Record<TIdKey, any>,
  TEntityName extends string = any,
  TIdKey extends keyof TData = keyof TData
>(
  entityName: TEntityName,
  idKey: TIdKey,
  responseService: IEntityResponseService<TData, TEntityName, TIdKey>,
) => {
  // Subscription statuses
  const SubscriptionStatus: {
    [key: string]: {
      status: 'NotSubscribing' | 'Subscribing';
    };
  } = {};

  const subscribeEntityInScope = (
    accessToken: string,
    scope: string | number | undefined,
    operations: EntityOperations<TData, TIdKey>,
  ) => {
    if (
      !SubscriptionStatus[getScopeKey(scope)] ||
      SubscriptionStatus[getScopeKey(scope)].status === 'NotSubscribing'
    ) {
      SubscriptionStatus[getScopeKey(scope)] = {status: 'Subscribing'};
      const handleEvent: HandleEventCallback<TData, TIdKey> = (
        eventType: EventTypes,
        message: TData | TData[],
      ) => {
        const resolvedMessages = message instanceof Array ? message : [message];
        switch (eventType) {
          case 'updated': {
            console.log('Got update on', entityName, 'with', message);
            operations.replace(resolvedMessages);
            break;
          }
          case 'added': {
            console.log('Got add on', entityName, 'with', message);
            operations.add(resolvedMessages);
            break;
          }
          case 'deleted': {
            console.log('Got remove on', entityName, 'with', message);
            operations.remove(resolvedMessages.map(m => m[idKey]));
            break;
          }
        }
      };

      responseService.subscribe(
        accessToken,
        scope,
        entityName,
        ['updated', 'added', 'deleted'],
        handleEvent,
      );
    }
  };

  const unsubscribe = (
    accessToken: string,
    scopeValue: string | number | undefined,
  ) => {
    if (
      SubscriptionStatus[getScopeKey(scopeValue)] &&
      SubscriptionStatus[getScopeKey(scopeValue)].status === 'Subscribing'
    ) {
      SubscriptionStatus[getScopeKey(scopeValue)].status = 'NotSubscribing';
      responseService.unsubcribe(accessToken, scopeValue, entityName);
    }
  };

  return {subscribe: subscribeEntityInScope, unsubscribe};
};

const getScopeKey = (value: string | number | undefined) => {
  return value || 'default';
};
